/** 공개 사이트 페이지 본문 문구 — ko/landingPages.ts 와 같은 키(정본은 ko). */
const landingPages = {
  news: {
    eyebrow: "報道資料",
    title: "報道資料",
    count: "全{{n}}件",
    listLabel: "記事一覧",
    readMore: "記事を読む",
    openLabel: "{{title}} — 記事を見る",
    back: "一覧に戻る",
    original: "元記事を見る",
    empty: "まだ記事はありません。",
    imageUnavailable: "画像を読み込めません",
    translatedFrom: {
      ja: "日本語の原文を韓国語に翻訳した記事です。",
    },
    related: {
      title: "合わせて見る",
      platform: {
        alt: "DroneSquare アプリのアイコンタイルがオルソ画像・図面・3Dレイヤーの板の上に浮かぶ図",
        kicker: "サービスプラットフォーム",
        title: "ドローン基盤のインフラ管理プラットフォーム",
        text: "ドローンで撮影した現場を2D・3Dで点検し、記録します。",
      },
      releases: {
        alt: "数字3の通知バッジが付いた金色の通知ベルが鳴り、その下に DroneSquare アプリの通知カードがある図",
        kicker: "アップデート情報",
        title: "さらに新しくなったドローンスクエア",
        text: "新たに加わった機能をデモ動画とあわせてご覧ください。",
      },
    },
  },
  plan: {
    title: "ドローンスクエア サービスプラン",
    lead: "ドローンスクエアの正確なデータ分析で<br/>現場をモニタリングし、最適な維持管理を実現しましょう。",
    plansLabel: "プラン",
    standard: {
      name: "Standard Plan",
      description: "<b>小規模な対象（現場）</b>を<br/>分析・管理したい場合",
      features: [
        "月額サブスクリプション",
        "ドローン画像3000枚 / ドローンプロジェクト構築",
        "月2回のデータ処理",
      ],
    },
    advanced: {
      name: "Advanced Plan",
      description: "<b>大規模な対象（現場）</b>を<br/>分析・管理したい場合",
      features: [
        "年額サブスクリプションで\n各種利用オプションを柔軟に協議",
        "ドローン画像3000枚以上 / ドローンプロジェクト構築",
      ],
    },
    ask: "お問い合わせ",
    compare: {
      title: "ひと目で比較",
      item: "項目",
      rows: [
        {
          label: "対象",
          standard: "小規模な対象（現場）",
          advanced: "大規模な対象（現場）",
        },
        {
          label: "契約方式",
          standard: "月額",
          advanced: "年額",
        },
        {
          label: "ドローンプロジェクト構築",
          standard: "ドローン画像3000枚",
          advanced: "ドローン画像3000枚以上",
        },
        {
          label: "データ処理",
          standard: "月2回",
          advanced: "利用オプションを柔軟に協議",
        },
      ],
    },
    related: {
      title: "プランと合わせて見る",
      platform: {
        alt: "DroneSquare アプリのアイコンタイルがオルソ画像・図面・3Dレイヤーの板の上に浮かぶ図",
        kicker: "プラットフォーム",
        title: "ドローン基盤のインフラ管理プラットフォーム",
        text: "2D・3D・4D、測量・断面、あらゆるデータの重ね合わせと現場記録まで一つの画面で。",
      },
      survey: {
        alt: "水面の上を飛ぶドローン",
        kicker: "ドローン測量と空間データ加工",
        title: "撮影からプラットフォームまでおまかせ",
        text: "ドローン運用の専門家が飛行承認からプラットフォームまで直接進めます。",
      },
    },
    closing: {
      eyebrow: "DroneSquare 1:1 お問い合わせ",
      title: "現場に合ったプランを<br/>一緒に決めましょう",
    },
  },
  inquiry: {
    eyebrow: "1:1 お問い合わせ",
    title: "DroneSquare 1:1 お問い合わせ",
    copy: "ドローンスクエアと一緒に<br/><em>スマートなインフラ資産管理・分析</em>",
    photoAlt: "現場の上を飛ぶ撮影用ドローン",
    chatTitle: "DroneSquare 1:1 相談",
    chatFallback: "このブラウザでは相談ウィンドウを表示できません。",
    chatLoading: "相談ウィンドウを開いています",
    chatFailedTitle: "相談ウィンドウを開けませんでした",
    chatFailedText:
      "しばらくしてからもう一度お試しいただくか、代表電話までお問い合わせください。",
    chatRetry: "もう一度試す",
    chatCall: "代表電話 {{tel}}",
    chatOpen: "チャットで問い合わせる",
    chatClose: "閉じる",
    moreTitle: "お問い合わせの前にご確認ください",
    manual: {
      alt: "DroneSquare アプリのアイコンタイルの横に、ステップ1・2・3が書かれた案内カードとカーソルがある図",
      kicker: "マニュアル",
      title: "画面ごとの使い方",
      text: "プロジェクト作成から3D計測まで、順に試してみましょう。",
    },
    plan: {
      alt: "DroneSquare アプリのアイコンタイルの横に Standard・Advanced のプランカード2枚がある図",
      kicker: "料金プラン",
      title: "Standard · Advanced",
      text: "現場の規模に合ったプランを比較してみましょう。",
    },
    survey: {
      alt: "等角の現場ボードの上を点線の経路で飛ぶドローンと数値地形図の成果カードがある図",
      kicker: "ドローン測量サービス",
      title: "撮影からプラットフォームまで",
      text: "ドローン運用の専門家が直接撮影・処理します。",
    },
  },
  survey: {
    eyebrow: "ドローン測量と空間データ加工",
    title: "専門家がつくる<br/>end-to-end ドローンソリューション",
    description:
      "ドローン運用の専門家がお客様の要件に合わせ、対象地域の撮影から高精度な地図の作成まで迅速かつ正確に行います。",
    heroAlt: "森の上を飛ぶ白い撮影用ドローン",
    ask: "お問い合わせ",
    process: {
      eyebrow: "進行手順",
      title: "飛行承認から<br/>プラットフォームまで",
    },
    results: {
      eyebrow: "成果物",
      title: "一度の撮影でつくる成果物",
      lead: "すべての成果物はドローンスクエアのプラットフォームにアップロードし、2D・3D画面ですぐに確認できます。",
      tabsLabel: "成果物の種類",
      tabs: [
        {
          name: "オルソ画像",
          note: "歪みを補正した高解像度の地図",
          alt: "成果物：オルソ画像。土工現場を北東の上空から斜めに見た地図面。",
        },
        {
          name: "DSM",
          note: "地表面の高さモデル",
          alt: "成果物：同じ視点のDSM。低い所は青、高い所は赤で塗られている。",
        },
        {
          name: "Point Cloud",
          note: "写真を整合して作った点データ",
          alt: "成果物：同じ視点の点群。現場が細かな色の点で立体的に見える。",
        },
        {
          name: "3Dモデル",
          note: "実写テクスチャの立体モデル",
          alt: "成果物：同じ視点の3Dモデル。削られた法面と進入路が立体的に見える。",
        },
        {
          name: "簡易数値地形図",
          note: "1メートル間隔の等高線",
          alt: "成果物：同じ視点の簡易数値地形図。1メートル間隔の等高線と5メートルの計曲線。",
        },
      ],
    },
    closing: {
      eyebrow: "プラットフォーム",
      title: "ドローン基盤の<br/>インフラ管理プラットフォーム",
      more: "詳しく見る",
      ask: "お問い合わせ",
    },
  },
  accurate: {
    eyebrow: "プラットフォーム",
    title: "ドローン基盤の<br/>インフラ管理プラットフォーム",
    description:
      "ドローンスクエアを導入し、空間データを価値あるビジネスインテリジェンスに変えましょう。",
    start: "始める",
    ask: "お問い合わせ",
    heroVideoLabel:
      "DroneSquare の3D点検画面全体。左の課題パネルとツールバー、ドローンで作った掘削工事現場の3Dモデルを斜めから見下ろしながらゆっくり回る映像。",
    index: {
      title: "現場のすべてのデータを<br/>一つの画面で",
      label: "プラットフォーム機能",
      items: [
        {
          title: "2D · 3D · 4D",
          text: "オルソ画像と3Dモデルを行き来し、画面を分割して撮影日ごとに比較します。",
        },
        {
          title: "測量 · 断面 · 土工",
          text: "線を引いて地形と構造物の断面を見て、土工量と長さ・面積・体積を測ります。",
        },
        {
          title: "すべてのデータ",
          text: "DXF・GIS・BIM・点群・ベクターを一つの3D画面に重ねて切って見ます。",
        },
        {
          title: "現場記録 · 作業状況",
          text: "課題と写真・動画・360°を位置ごとに残し、機材動線の危険を確認します。",
        },
      ],
    },
    site: {
      eyebrow: "現場記録 · 作業状況",
      title: "現場の記録と機材の危険まで<br/>一つの地図で",
      lead: "課題と写真・動画・360°の記録を位置ごとに残し、<brd/>機材の動線を事前に動かして作業半径が重なる場所を確認しましょう。",
    },
    more: {
      title: "さらに詳しく",
      survey: {
        alt: "水面の上を飛ぶ撮影用ドローン",
        kicker: "ドローン測量と空間データ加工",
        title: "専門家がつくる end-to-end ドローンソリューション",
        text: "飛行承認からプラットフォームまで、ドローン運用の専門家が直接進めます。",
      },
      plan: {
        alt: "Standard・Advanced のプランカード2枚が並んだ図",
        kicker: "料金プラン",
        title: "ドローンスクエア サービスプラン",
        text: "現場の規模に合った Standard、Advanced プランを比較してみましょう。",
      },
    },
    closing: {
      eyebrow: "次のステップ",
      title: "ドローン測量と<br/>空間データ加工",
      more: "詳しく見る",
      ask: "お問い合わせ",
    },
  },
  landing: {
    hero: {
      title: "ドローン基盤の インフラ管理プラットフォーム",
      ask: "お問い合わせ",
      start: "始める",
      sceneLabel:
        "ドローンが掘削工事現場の上を飛びながら写真を撮り、写真が1枚のオルソ画像に合成された後、同じ場所が3Dモデルとして立ち上がる場面",
    },
    service: {
      eyebrow: "ドローン測量と空間データ加工",
      title: "専門家がつくる<br/>end-to-end ドローンソリューション",
      lead: "ドローン運用の専門家がお客様の要件に合わせ、<brd/>対象地域の撮影から高精度な地図の作成まで迅速かつ正確に行います。",
    },
    closing: {
      eyebrow: "DroneSquare 1:1 お問い合わせ",
      title: "ドローンスクエアと一緒に、スマートなインフラ資産管理・分析を",
    },
  },
  status: {
    home: "ホームへ",
    notFound: {
      title: "ページが見つかりません",
      lead: "アドレスが変わったか、ページが削除された可能性があります。",
    },
    prepare: {
      title: "このページは準備中です",
      lead: "できるだけ早くご用意します。",
    },
  },
  meta: {
    siteName: "DroneSquare",
    imageAlt:
      "ドローン写真を一枚に合わせた工事現場のオルソ画像の上に、左に DroneSquare ロゴと DroneSquare、その下に「ドローン基盤のインフラ管理プラットフォーム」が置かれた画像",
    landing: {
      title: "DroneSquare | ドローン基盤のインフラ管理プラットフォーム",
      description:
        "ドローンで撮影した現場を 2D・3D で確認し、点検・管理するインフラ管理プラットフォームです。",
    },
    accurate: {
      title: "プラットフォーム | DroneSquare",
      description:
        "DroneSquare を導入して、空間データを価値あるビジネスインテリジェンスに変えましょう。",
    },
    survey: {
      title: "ドローン測量・空間データ加工 | DroneSquare",
      description:
        "ドローン運用の専門家が飛行承認からオルソ画像・DSM・3D モデル・簡易数値地形図まで直接作成します。",
    },
    plan: {
      title: "料金プラン | DroneSquare",
      description:
        "現場の規模に合わせて Standard と Advanced プランを比べてみてください。",
    },
    inquiry: {
      title: "1:1 お問い合わせ | DroneSquare",
      description:
        "DroneSquare の導入・ご利用に関するお問い合わせをチャットと代表電話で承ります。",
    },
    news: {
      title: "報道資料 | DroneSquare",
      description: "DroneSquare を取り上げた報道記事をまとめました。",
    },
    manual: {
      title: "マニュアル | DroneSquare",
      description:
        "動画に沿って DroneSquare の画面ごとの使い方を覚えましょう。",
    },
    releases: {
      title: "アップデート情報 | DroneSquare",
      description:
        "最先端の現場技術を DroneSquare でいち早く体験してください。",
    },
    privacy: {
      title: "Privacy Policy | DroneSquare",
      description:
        "What personal information DroneSquare collects, why, how long it is kept, who processes it, and your rights.",
    },
    login: {
      title: "ログイン | DroneSquare",
      description: "DroneSquare アカウントでログインします。",
    },
    signup: {
      title: "会員登録 | DroneSquare",
      description: "DroneSquare アカウントを作成します。",
    },
    changepassword: {
      title: "パスワード変更 | DroneSquare",
      description:
        "登録したメールアドレスで認証番号を受け取り、パスワードを変更します。",
    },
    notFound: {
      title: "ページが見つかりません | DroneSquare",
      description: "アドレスが変わったか、ページが削除された可能性があります。",
    },
    prepare: {
      title: "準備中 | DroneSquare",
      description: "できるだけ早くご用意します。",
    },
    article: {
      title: "{{title}} | DroneSquare 報道資料",
    },
  },
} as const;

export default landingPages;
